import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { db } from "./db";

export const fillArticleOverviewDB = () => {
    return db.articlesOverview.count(async function (count: number) {
        if (count > 0) {
            //console.log("ArticleOverview Already populated");
        } else {
            //console.log("ArticleOverview Database is empty. Populating from ajax call...");
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticlesOverview()
                .then((data) => {
                    //console.log(data)
                    //console.log("Got ajax response. We'll now add the objects.");
                    //console.log("Calling bulkAdd() to insert objects...");
                    if (data) {
                        //set("dbTimestamp", new Date());
                        return db.articlesOverview.bulkAdd(data);
                    }
                })
                .then(() => {
                    //console.log("Done populating.");
                    return db.timestamps.add({ name: "articlesOverview", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const deleteArticleOverviewTable = async () => {
    return db.articlesOverview.clear().then(() => {
        //console.log("Database successfully cleared");
    }).catch((err) => {
        //console.error("Could not clear database");
    })
}

export const updateArticleOverviewTable = async () => {
    await ArticleService.getArticlesOverview()
        .then(async (data) => {
            await deleteArticleOverviewTable().then(() => {
                //@ts-ignore
                return db.articlesOverview.bulkPut(data);
            })
        })
        .then(() => {
            //console.log("Done refilling.");
            return db.timestamps.put({ name: "articlesOverview", timestamp: String(new Date()) })
        })
        .catch(err => console.log(err));
}
